// extracted by mini-css-extract-plugin
export default {"form":"Form_form__uMwM0","inputbox":"Form_inputbox__82eHc"};